import { I18n } from "utils/i18n-shim"
import moment from "moment"

import { hasAnyOfRoles } from "utils/user"

export const getLanguages = () => [{ id: "en" }, { id: "de" }]

export const getLanguageLabel = (language) =>
  language?.id ? I18n.t(`app.langs.${language.id}`) : ""

export const getGenders = () => [
  { id: "male" },
  { id: "female" },
  { id: "unisex" }
]

export const getGenderLabel = (gender) =>
  gender?.id ? I18n.t(`app.genders.${gender.id}`) : ""

export const getSalutationLabel = (gender) =>
  I18n.t(`app.salutations.${gender.id}`)

export const isSalutationCustom = (value) => {
  return value && !Object.values(I18n.t("app.salutations")).includes(value)
}

export const getInitialLoginValues = () => {
  return { email: "", password: "", otp_attempt: "" }
}

export const getInitialChangePasswordValues = ({
  passwordToken,
  confirmationToken
}) => {
  return {
    current_password: "",
    password: "",
    password_confirmation: "",
    reset_password_token: passwordToken,
    confirmation_token: confirmationToken
  }
}

export const getInitialRequestChangePasswordValues = () => {
  return { email: "" }
}

export const formatCompanyName = (companyName) => companyName || "-"

export const formatLastLogin = (date) =>
  date
    ? moment(date).format("DD.MM.YYYY — HH:mm:ss")
    : I18n.t("users.last-login.never")

export const isEndCustomerUser = (user) =>
  user.account_owner_type === "end_customer" &&
  user.jap_customer?.type === "EndCustomer"

export const isAgencyCustomerUser = (user) =>
  user.account_owner_type === "end_customer" &&
  user.jap_customer?.type === "AgencyCustomer"

export const isPartnerCustomerUser = (user) =>
  user.account_owner_type === "end_customer" &&
  user.jap_customer?.type === "PartnerCustomer"

export const isCustomerDashboardUser = (user) =>
  isEndCustomerUser(user) ||
  isAgencyCustomerUser(user) ||
  isPartnerCustomerUser(user)

export const getShopPath = (user) => {
  if (
    hasAnyOfRoles(user, [
      "agency",
      "agencyAccountMember",
      "agencyAccountAdmin",
      "agencyManager",
      "producer"
    ])
  ) {
    return "/r/agency/shop"
  }

  if (
    hasAnyOfRoles(user, [
      "partner",
      "partnerAccountMember",
      "partnerAccountAdmin"
    ])
  ) {
    return "/r/partner/shop"
  }

  if (
    hasAnyOfRoles(user, [
      "endCustomer",
      "endCustomerAccountMember",
      "endCustomerAccountAdmin"
    ])
  ) {
    return isAgencyCustomerUser(user)
      ? "/r/agency-customer/orders/management"
      : "/r/end-customer/shop"
  }

  return "/"
}

export const isAgencyOfferEnabled = (user) => {
  const agencyOrAgencyMember = hasAnyOfRoles(user, [
    "agency",
    "agencyAccountMember",
    "agencyAccountAdmin"
  ])
  const canManageOffer = user.agency?.manage_offer
  const agencyOffersEnabled = user.account_member_data?.agency_offers_enabled

  return (agencyOrAgencyMember && canManageOffer) || agencyOffersEnabled
}

export const twoFactorAuthSetupParams = (values, responseBody) => ({
  pathname: "/r/2fa-setup",
  state: {
    email: values.email,
    password: values.password,
    disable_otp_by_email: responseBody.disable_otp_by_email,
    otp_secret: responseBody.otp_secret,
    generated_otp_provisioning_uri: responseBody.generated_otp_provisioning_uri
  }
})
